import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface ITrashFolderParams {
  folderId: string;
}

export async function trashFolder({
  folderId,
}: ITrashFolderParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/folder/trash', {
    method: 'POST',
    body: { folderId },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to trash folder',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
